import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import FoReportLayer from "../../../components/Admin/FoReportLayer";

const FoReport = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <FoReportLayer />
      </MasterLayout>
    </>
  );
};

export default FoReport
